// webpack inserts code here
window.buildData = "ver3-330-0-2025-09-17_01-52-45.d2f70916";

const config = (window as any).env;
export const SERVER_URL: string = config.SERVER_URL;
export const GAME_HISTORY_URL: string = config.GAME_HISTORY_URL;
export const IS_PROD: boolean = config.IS_PROD;
export const IS_KOALA: number = config.IS_KOALA;
export const CONSTANTS: any = {
    message_duration: 5, // in seconds
    game_history_languages: [
        'da',
        'de',
        'el',
        'en',
        'es',
        'it',
        'ja',
        'ko',
        'nl',
        'pl',
        'pt',
        'ro',
        'sv',
        'zh',
    ],
    dateFormat: 'DD/MM/YYYY',
    dateFormatWithTime: 'HH:mm:ss - DD/MM/YYYY',
};
